import React from 'react';
import { Flex, Text, Highlight } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { MdChevronLeft } from 'react-icons/md';

import { useGroup } from '../hooks/useGroup';
import { useUser } from '../hooks/useUser';
import { useSchedule } from '../hooks/useSchedule';
import Header from '../components/Header';

const MemberItem = ({ uid }: { uid: string }) => {
  const user = useUser(uid);
  if (!user) {
    return null;
  }
  return (
    <Text fontSize="20px" fontWeight="semibold" color="#383838">
      {user.name}
    </Text>
  );
};

const MemberList = () => {
  const { groupId, scheduleId } = useParams();
  const { group } = useGroup(groupId!);
  const { schedule } = useSchedule(groupId!, scheduleId || 'empty');
  if (!group) {
    return null;
  }
  const members = schedule ? schedule.members : group.members;

  return (
    <Flex
      pos="relative"
      h="100%"
      flexDirection="column"
      align="center"
      px="1rem"
      pb={8}
    >
      <Header title="멤버 목록" leftIcon={MdChevronLeft} leftTo={-1} />
      <Text
        color="#383838"
        width="100%"
        fontWeight="bold"
        fontSize="18px"
        mt="20px"
        mb="14px"
      >
        <Highlight query={`${members.length}`} styles={{ color: '#467FEC' }}>
          {`총 ${members.length}명`}
        </Highlight>
      </Text>
      <Flex width="100%" flexDir="column" gap="16px">
        {members.map((uid) => (
          <MemberItem key={uid} uid={uid} />
        ))}
      </Flex>
    </Flex>
  );
};

export default MemberList;
